// This file is auto-generated by @hey-api/openapi-ts
import { client as _heyApiClient } from './client.gen.js';
/**
 * List organizations (optionally filtered by status).
 */
export const listOrgs = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/admin/orgs',
        ...options
    });
};
/**
 * Inspect any organization (RLS-bypassing role).
 */
export const getOrg = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/admin/orgs/{id}',
        ...options
    });
};
/**
 * Move org from `pending` to `active`.
 */
export const approveOrg = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/admin/orgs/{id}/approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Move org from `active` to `suspended`.
 */
export const suspendOrg = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/admin/orgs/{id}/suspend',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Cross-org audit search.
 */
export const searchAudit = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/admin/audit',
        ...options
    });
};
